import { Link } from "@inertiajs/react"
import { Accordion, AccordionGroup, AccordionItem } from "@/components/ui/accordion"
import { Button } from "@/components/ui/button"
import { ConsultationBand, PublicHero, PublicShell } from "@/components/PublicShell"
import { PublicMeta } from "@/components/public/PublicMeta"

const TITLE = "FAQs: Bespoke Wine Labels & Orders"
const DESCRIPTION =
  "Answers on minimum orders, artwork and bespoke wine label design, UK delivery and the South African wines themselves: the questions we are asked most."

export type FaqRecord = {
  question: string
  answer: string
}

export type FaqGroup = {
  topic: string
  label: string
  faqs: FaqRecord[]
}

export default function Faqs({ faq_groups: faqGroups }: { faq_groups: FaqGroup[] }) {
  return (
    <PublicShell>
      <PublicMeta title={TITLE} description={DESCRIPTION} />
      <PublicHero
        eyebrow="Answers"
        title="Frequently Asked Questions"
        lede="Minimum orders, artwork, delivery and the wines themselves — answered plainly."
      />

      <section className="band band-black">
        <div className="shell">
          <Accordion>
            {faqGroups.map((group) => (
              <AccordionGroup title={group.label} key={group.topic}>
                {group.faqs.map((faq) => (
                  <AccordionItem question={faq.question} key={faq.question}>
                    <p>{faq.answer}</p>
                  </AccordionItem>
                ))}
              </AccordionGroup>
            ))}
          </Accordion>

          <div className="occ-steps-cta">
            <Button asChild variant="ghost-hairline" size="lg">
              <Link href="/contact">Still have a question? Contact us</Link>
            </Button>
          </div>
        </div>
      </section>

      <ConsultationBand brochure />
    </PublicShell>
  )
}
